import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import RequisitionForm from './components/RequisitionForm';
import Requisitions from './components/Requisitions';
import RequisitionSubmissionSuccessMessage from './components/RequisitionSubmissionSuccessMessage';
import ViewRequisition from './components/ViewRequisition';
import SurrenderForm from './components/SurrenderForm';
import Settings from './components/Settings';
import ReviewRequisition from './components/ReviewRequisition';
import StaffRequisitions from './components/StaffRequisitions';
import ChangePassword from './components/ChangePassword';
import Surrenders from './components/Surrenders';
import ReviewSurrender from './components/ReviewSurrender';
import EveryonesReviewedRequisitions from './components/EveryonesReviewedRequisitions';
import AddUser from './components/AddUser';
import Notifications from './components/Notifications';
import RequireAuth from './components/RequireAuth';
import useAutoLogout from './hooks/useAutoLogout';
import PopupModal from './components/PopupModal';
import ViewUsers from './components/ViewUsers';
import EditUser from './components/EditUser'; 
import CostDriverAdmin from "./components/CostDriverAdmin";
import CostDriverDropDownManager from './components/CostDriverDropDownManager';
import Approved from './components/Approved';
import ViewSurrender from './components/ViewSurrender';
import StaffSurrenders from './components/StaffSurrenders';
import StaffSurrendersSummary from './components/StaffSurrendersSummary';
import ApprovedRequisitions from './components/ApprovedRequisitions';
import ApprovedRequisitionsReviewerView from './components/ApprovedRequisitionsReviewerView';

const AppWrapper = () => {
  const navigate = useNavigate();

  useAutoLogout();

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'logout') {
        navigate('/login');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [navigate]);

  return <AppRoutes />;
};

const AppRoutes = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  console.log('From App - User from localStorage:', user);

  return (
    <Routes>
      <Route path="*" element={<Navigate to="/login" />} />
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/login" element={<Login />} />
      <Route path="/reqform" element={<RequireAuth><RequisitionForm /></RequireAuth>} />
      <Route path="/requisitions" element={<RequireAuth><Requisitions /></RequireAuth>} />
      <Route path="/success" element={<RequireAuth><RequisitionSubmissionSuccessMessage /></RequireAuth>} />
      <Route path="/view-requisition/:requisitionID" element={<RequireAuth><ViewRequisition /></RequireAuth>} />
      <Route path="/surrender/:requisitionID" element={<RequireAuth><SurrenderForm /></RequireAuth>} />
      <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
      <Route path="/settings/change-password" element={<RequireAuth><ChangePassword /></RequireAuth>} />
      <Route path="/review-requisition/:requisitionID" element={<RequireAuth><ReviewRequisition /></RequireAuth>} />
      <Route path="/staff-requisitions" element={<RequireAuth><StaffRequisitions /></RequireAuth>} />
      <Route path="/staff-surrenders" element={<RequireAuth><StaffSurrenders /></RequireAuth>} />
      <Route path="/staff-surrenders-summary" element={<RequireAuth><StaffSurrendersSummary /></RequireAuth>} />      
      <Route path="/everyones-reviewed-requisitions" element={<RequireAuth><EveryonesReviewedRequisitions /></RequireAuth>} />
      <Route path="/surrenders" element={<RequireAuth><Surrenders /></RequireAuth>} />
      <Route path="/review-surrender/:requisitionID" element={<RequireAuth><ReviewSurrender /></RequireAuth>} />
      <Route path="/add-user" element={<RequireAuth><AddUser /></RequireAuth>} />
      <Route path="/notifications" element={<RequireAuth><Notifications /></RequireAuth>} />
      <Route path="/pop" element={<RequireAuth><PopupModal /></RequireAuth>} />
      <Route path="/view-users" element={<RequireAuth><ViewUsers /></RequireAuth>} />
      <Route path="/edit-user/:id" element={<RequireAuth><EditUser /></RequireAuth>} />
      <Route path="/admin/cost-drivers" element={<CostDriverAdmin />} />
      <Route path="/cost-driver-dropdown" element={<RequireAuth><CostDriverDropDownManager /></RequireAuth>} />
      <Route path="/approved" element={<RequireAuth><Approved /></RequireAuth>} />
      <Route path="/view-surrender/:requisitionID" element={<RequireAuth><ViewSurrender /></RequireAuth>} />
      <Route path="/approved-requisitions" element={<RequireAuth><ApprovedRequisitions /></RequireAuth>} />
      <Route path="/approved-requisitions-reviewer-view" element={<RequireAuth><ApprovedRequisitionsReviewerView /></RequireAuth>} />
      
    </Routes> 
  );
};

const App = () => (
  <Router>
    <AppWrapper />
  </Router>
);

export default App;
